import React, { useState, useEffect } from "react"
import _ from "lodash"
// Styles
import { Label_s } from 'styles/app-styles'
import { MultipleRow_s } from 'components/table/hovers/hover-styles'

type IHover = {
  data: {}
  namedItems: {}
}

const ObjectsHover = (props: IHover) => {
  const type = _.get(props, "data.objects.type")
  const objects = type === "property" ? _.get(props, "namedItems.properties") : _.get(props, "namedItems.portfolios")
  const selectedObjects = _.get(props, "data.objects.ids")
  let prefix = type === "property" ? "Properties" : "Portfolios"

  if(selectedObjects.length === 1) {
    let obj = type === "property" ? _.find(objects, (o) => o.propertyid === selectedObjects[0]) : _.find(objects, (o) => o.portfolioid === selectedObjects[0])
    let code = _.get(obj, "code")
    prefix = type === "property" ? "Property:" : "Portfolio:"
    return <span>{`${prefix} ${code}`}</span>
  } else return (
    <div style={{padding: "5px"}}>
      <MultipleRow_s>
        <table>
          <thead>
            <th>
              <Label_s>{prefix}</Label_s>
            </th>
          </thead>
          { _.chain(selectedObjects).take(3).map((s, i) => {
            let obj = type === "property" ? _.find(objects, (o) => o.propertyid === s) : _.find(objects, (o) => o.portfolioid === s)
            let code = _.get(obj, "code")
            return (
              <tr>
                <span>{code}</span>
              </tr>
            )
          }).value() }
        </table>
        { (selectedObjects.length > 3) && <div style={{marginLeft: 'auto', textAlign: 'right'}}><strong>...</strong></div>}
      </MultipleRow_s>
    </div>
  )
}

export default ObjectsHover
